<template>
    <div id="student-notifications" class="card">
        <div class="card-body">
            <h5 class="card-title"><i class="fas fa-bell"></i> My Notifications</h5>
            <div class="card-text">
                <!-- Triage submission -->
                <div v-if="notificationsData.length == 0" class="alert alert-primary" role="alert">
                    <p> <i class="fas fa-user-check"></i> There are currently no notificatons. Please continue to
                        monitor this section to get up-to-date information on whether you have been sent a notification
                        about your
                        upcoming academic counselling appointment.
                    </p>
                </div>
                <div v-else class="card mb-2" v-for="(item, i) in notificationsData" :key="i">
                    <div class="card-body notification-body">
                        <div class="card-subtitle font-weight-bold mb-2">
                            Subject: {{ getSubject(item) }}
                        </div>
                        <div class="card-subtitle mb-3 mt-1 text-muted">
                            {{ getDateTime(item.timestamp) }}</div>
                        <div class="card-subtitle">Message:</div>
                        <div class="card-text">
                            <small>
                                {{ item.notification.textmessage }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'student-notifications',
    props: {
        notificationsData: {
            required: true
        }
    },
    methods: {
        getDateTime(timestamp) {
            let date = new Date(timestamp * 1000);
            return `${date.toLocaleString()}`;
        },
        getSubject(item) {
            if (item && item.notification && item.notification.subject) {
                return `${item.notification.subject}`
            }

            return `Notification`
        }
    }
}
</script>

<style scoped>
.notification-body {
    line-height: 16px;
}
</style>